import React from "react";
import "./promoanniv.scss";
import Comingsoon from "../../media/New_Desktop.webp";
import Soon from "../../media/New_Mobile.webp";

const handleConsultationClick = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=6285862346884&text=Halo%20Fatah,%20Saya%20bisa%20minta%20detail%20Promo%20terbaru%20Summarecon%20Bandung%20(New%20Launching%20Diamond%20Commercial)%20https://marketing-summabandung.com//&type=phone_number&app_absent=0";
  window.open(whatsappLink, "_blank");
};

const soon = () => {
  return (
    <div id="promoanniversary" className="container-soon">
      <div className="louise">
        <h1>New Launching Ruko Diamond Commercial</h1>
      </div>
      <div className="maps-lokasi">
        <img
          id="location"
          className="img-lokasi-dekstop"
          src={Comingsoon}
          alt="maps"
        />
        <img id="lokasi" className="img-lokasi-mobile" src={Soon} alt="maps" />
      </div>
      <div className="button">
        <div className="container-wa">
          <button className="buttonpenawaran" onClick={handleConsultationClick}>
            More Info
          </button>
        </div>
      </div>
    </div>
  );
};

export default soon;
